exports.DonatorsPageView = require('./DonatorsPageView').default;
exports.DonatorsCreatePageView = require('./DonatorsCreatePageView').default;
exports.DonatorsUpdatePageView = require('./DonatorsUpdatePageView').default;
exports.DonatorsSelectCampaignPageView = require('./DonatorsSelectCampaignPageView').default;
exports.DonatorsExportPageView = require('./export/DonatorsExportPageView').default;
exports.DonatorsImportPageView = require('./import/DonatorsImportPageView').default;
exports.DonatorsDetailPageView = require('./DonatorsDetailPageView').default;
